import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Button, Col, Row } from "reactstrap";
import InvoiceByOffer from "./InvoiceByOffer";
import InvoiceCustom from "./InvoiceCustom";
import InvoiceSalary from "./InvoiceSalary";
import { AvForm } from "availity-reactstrap-validation";
import CustomMiniLoader from "../../CustomMiniLoader/CustomMiniLoader";

const InvoiceType = props => {
  const getForm = () => {
    switch (props.type) {
      case "offer":
        return (
          <div>
            <FormByCostTypeStyled
              key={props.type + "_1"}
              className="fade-in-custom-animate-1s"
            >
              <InvoiceByOffer
                choices={props.choices}
                offers={props.offers}
                offers_loading={props.offers_loading}
                isFormSubmit={props.isFormSubmit}
                legal_entity={props.legal_entity.results}
                legal_entity_loader={props.legal_entity_loader}
                contractors={props.contractors}
                getOffersByContract={props.getOffersByContract}
                contractOffers={props.contractOffers}
                contractOffersLoader={props.contractOffersLoader}
              />
            </FormByCostTypeStyled>
            <Row>
              <Col sm="6"></Col>
              <Col sm="6">
                <div className="text-end mb-5">
                  {props.loading_invoice ? (
                    <CustomMiniLoader
                      style={{ padding: "10px", minWidth: "143px" }}
                      status
                      text="Please wait"
                    />
                  ) : (
                    <Button
                      color="success"
                      style={{ padding: "10px", minWidth: "143px" }}
                    >
                      Create invoice
                    </Button>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        );
      case "custom":
        return (
          <div>
            <FormByCostTypeStyled
              key={props.type + "_2"}
              className="fade-in-custom-animate-1s"
            >
              <InvoiceCustom
                choices={props.choices}
                clients={props.clients}
                client={props.client}
                countries={props.countries}
                onGetClientById={props.onGetClientById}
                setClient={props.setClient}
                isFormSubmit={props.isFormSubmit}
                contractors={props.contractors}
                legal_entity={props.legal_entity}
                onChangeSelected={props.onChangeSelected}
                toggleViewEditInvoiceModal={props.toggleViewEditInvoiceModal}
              />
            </FormByCostTypeStyled>
            <Row>
              <Col sm="6"></Col>
              <Col sm="6">
                <div className="text-end mb-5">
                  {props.loading_invoice ? (
                    <CustomMiniLoader
                      style={{ padding: "10px", minWidth: "143px" }}
                      status
                      text="Please wait"
                    />
                  ) : (
                    <Button
                      color="success"
                      style={{ padding: "10px", minWidth: "143px" }}
                    >
                      Create invoice
                    </Button>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        );
      case "salary":
        return (
          <div>
            <FormByCostTypeStyled
              key={props.type + "_3"}
              className="fade-in-custom-animate-1s"
            >
              <InvoiceSalary
                offers={props.offers}
                positions_loading={props.positions_loading}
                positions={props.positions}
                users_loading={props.users_loading}
                users={props.users}
                isFormSubmit={props.isFormSubmit}
                onGetUsersByPosition={props.onGetUsersByPosition}
                legal_entity={props.legal_entity.results}
                legal_entity_loader={props.legal_entity_loader}
                bonuses={props.bonuses}
                bonuses_loader={props.bonuses_loader}
                invoice_templates={props.invoice_templates.results}
                invoice_templates_loading={props.invoice_templates_loading}
                getBankDetailsForUser={props.getBankDetailsForUser}
                bankDetails={props.bankDetails}
                loading_details={props.loading_details}
              />
            </FormByCostTypeStyled>
            <Row>
              <Col sm="6"></Col>
              <Col sm="6">
                <div className="text-end mb-5">
                  {props.loading_invoice ? (
                    <CustomMiniLoader
                      style={{ padding: "10px", minWidth: "143px" }}
                      status
                      text="Please wait"
                    />
                  ) : (
                    <Button
                      color="success"
                      style={{ padding: "10px", minWidth: "143px" }}
                    >
                      Create invoice
                    </Button>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        );
      default:
        return <></>;
    }
  };

  const getSubmitFunction = () => {
    switch (props.type) {
      case "offer":
        return props.onSubmitOfferForm;
      case "custom":
        return props.onSubmitCustomForm;
      case "salary":
        return props.onSubmitSalaryForm;
    }
  };

  return (
    <Row className="justify-content-md-center">
      <AvForm onSubmit={getSubmitFunction()}>{getForm()}</AvForm>
    </Row>
  );
};

InvoiceType.propTypes = {
  type: PropTypes.string.isRequired,
  countries: PropTypes.arrayOf(PropTypes.object).isRequired,
  positions: PropTypes.arrayOf(PropTypes.object).isRequired,
  clients: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  contractors: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  legal_entity: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  offers: PropTypes.shape({
    results: PropTypes.arrayOf(PropTypes.object).isRequired,
  }).isRequired,
  choices: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
  bonuses: PropTypes.any.isRequired,
  bonuses_loader: PropTypes.bool.isRequired,
  offers_loading: PropTypes.bool.isRequired,
  legal_entity_loader: PropTypes.bool.isRequired,
  positions_loading: PropTypes.bool.isRequired,
  users_loading: PropTypes.bool.isRequired,
  users: PropTypes.arrayOf(PropTypes.object).isRequired,
  isFormSubmit: PropTypes.bool.isRequired,
  loading_invoice: PropTypes.bool.isRequired,
  onGetUsersByPosition: PropTypes.func.isRequired,
  toggleViewEditInvoiceModal: PropTypes.func,
  onGetClientById: PropTypes.func.isRequired,
  setClient: PropTypes.func.isRequired,
  onChangeSelected: PropTypes.func.isRequired,
  onSubmitSalaryForm: PropTypes.func.isRequired,
  onSubmitCustomForm: PropTypes.func.isRequired,
  onSubmitOfferForm: PropTypes.func.isRequired,
  getOffersByContract: PropTypes.func.isRequired,
  contractOffers: PropTypes.arrayOf(PropTypes.object),
  contractOffersLoader: PropTypes.boolean,
  invoice_templates: PropTypes.object,
  invoice_templates_loading: PropTypes.bool.isRequired,
  getBankDetailsForUser: PropTypes.func.isRequired,
  bankDetails: PropTypes.object.isRequired,
  loading_details: PropTypes.bool.isRequired,
};
const FormByCostTypeStyled = styled.div``;

export default InvoiceType;
